<template>
  <router-link :to="{ name: 'course.show', params: { id: course.id, slug: course.slug } }" class="course">
    <CourseThumb :course="course" class="course__thumb"/>

    <div class="flex-1 course__content">
      <h6 class="course__name mb-3">{{ course.name }}</h6>
      <BaseProgressBar :value="course.attended_percent"/>
    </div>
  </router-link>
</template>

<script>
import CourseThumb from '@/components/course/CourseThumb'
import BaseProgressBar from '@/components/progressbar/BaseProgressBar'

export default {
  components: {
    CourseThumb,
    BaseProgressBar,
  },

  props: {
    course: { type: Object, required: true }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/variables";

  .course {
    display: flex;
    align-items: center;
    gap: 15px;

    &__content {
      @media (max-width: $tabletBreakpoint) {
        text-align: center;
        width: 100%;
      }
    }

    &__thumb {
      flex: 0 0 auto;
      width: 140px;
    }

    &__name {

    }

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
</style>